'use strict';

angular.module('randomization')
.filter('randomizationUnblinded', ['gettext', function(gettext) {
    return function (unblind) {
        if (Array.isArray(unblind) && unblind.length > 0) {
            return gettext('Sí');
        } else {
            return gettext('No');
        }
    };
}]);
